import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const ImageIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.8571 7.42857H16M20 14.2783L16.5714 10.8519L13.1429 14.2783L8.57143 8.5677L4 14.2857M5.14286 4H18.8571C19.4883 4 20 4.51167 20 5.14286V18.8571C20 19.4883 19.4883 20 18.8571 20H5.14286C4.51168 20 4 19.4883 4 18.8571V5.14286C4 4.51168 4.51167 4 5.14286 4Z"
        stroke={iconColor}
        strokeWidth="1.5"
      />
    </Box>
  );
};
